export const initialState = {
  filters: {},
  questionnaires: [],
  questionnaire: {},
  totalCount: 0,
  loading: false
};
